/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { InputNumber } from "antd";
import { UserOutlined } from '@ant-design/icons';

class InputNumberlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      select2options: [],
    };
  }
  // componentDidMount() {
  //   console.log(this.props.selectdata);
  //   console.log(this.props.Queuedata);
  // }

  handleChange(value) {
    console.log(`selected ${value}`);
  }

  onChange(value) {
  
    this.props.onselectChanges({
      id: this.props.selectdata.name,
      value: value,
      parrentMode: this.props.selectdata.parrentMode,
      parrentName: this.props.selectdata.parrentName,
    });
  }

  render() {
    return (
      <div className="form-group">
        <InputNumber
          disabled={this.props.selectdata.disable}
          onChange={this.onChange.bind(this)}
          placeholder={this.props.selectdata.placeholder}
          value={this.props.selectdata.value}
          min={1}
          // prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
          prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
        />
      </div>
    );
  }
}

export default InputNumberlayer;
